import { clOpcionesEmpresaList } from '@/febos/servicios/api/configuraciones.api';

export default {
  data() {
    return {
      documents: [],
      referencesDocs: []
    };
  },
  methods: {
    findLabelDocument(typeDocument) {
      const documents = this.documents.concat(this.referencesDocs);
      const typeDoc = documents.find((doc) => doc.valor === typeDocument);
      return typeDoc ? typeDoc.descripcion : typeDocument;
    }
  },
  async created() {
    // FIXME:  Hay que ver esto
    const { data } = await clOpcionesEmpresaList({
    // const { data } = await listOptions({
      grupoOpcion: 'tipos-referencias-documentos',
      deshabilitado: 'no'
    });
    this.documents = data.opciones;
    // FIXME: Hay que ver esto
    const response = await clOpcionesEmpresaList({
    // const response = await listOptions({
      grupoOpcion: 'tipos.documentos-ed',
      deshabilitado: 'no',
      agrupar: 'si'
    });
    this.referencesDocs = response.data.opciones;
  }
};
